define('OutSystems/ClientRuntime/modules/Database/WebSQL/Upgrader/V0/MetadataTableInfo',["require", "exports", "../../../AutoNumber", "../../../DBDataType", "../../../TableInfoUtils"], function (require, exports, AutoNumber_1, DBDataType_1, TableInfoUtils_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var METADATA_TABLE_INFO = {
        tableName: TableInfoUtils_1.METADATA_TABLE_NAME,
        idIsAutoNumber: AutoNumber_1.default.No,
        attributes: [
            { name: "SS_Key", columnName: "SS_Key", type: DBDataType_1.default.TEXT },
            { name: "Module_SS_Key", columnName: "Module_SS_Key", type: DBDataType_1.default.TEXT },
            { name: "Name", columnName: "Name", type: DBDataType_1.default.TEXT },
            { name: "Physical_Table_name", columnName: "Physical_Table_name", type: DBDataType_1.default.TEXT },
            { name: "Hash", columnName: "Hash", type: DBDataType_1.default.TEXT },
            { name: "Extra_Info", columnName: "Extra_Info", type: DBDataType_1.default.TEXT },
            { name: "Upgrade_Status", columnName: "Upgrade_Status", type: DBDataType_1.default.INTEGER },
        ],
    };
    exports.default = METADATA_TABLE_INFO;
});
//# sourceMappingURL=MetadataTableInfo.js.map;
